import React from "react";
import { useTranslation } from "react-i18next";
import { twJoin } from "tailwind-merge";
import { TopBar } from "@components/TopBar/TopBar";
import { Error } from "./Error";

interface IErrorBoundaryProps {
  showTopBar?: boolean;
}

export const ErrorBoundary: React.FC<IErrorBoundaryProps> = (props) => {
  const { showTopBar } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {showTopBar && <TopBar />}
      <Error
        className={twJoin(showTopBar ? "h-full" : "h-screen")}
        title={t("errorBoundary.title")}
        description={t("errorBoundary.description")}
      />
    </React.Fragment>
  );
};
